<template>
    <div>
        <b-row class="mb-4">
            <b-col cols="12">
                <b-card>
                    <b-row>
                        <b-col>
                            <h4>Quotation Reporting</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <label>Client</label>
                            <b-form-input v-model="search.customer"></b-form-input>
                        </b-col>
                        <!-- <b-col cols="4">
                            <label>Ticket Number</label>
                            <b-form-input v-model="search.jobCardNumber"></b-form-input>
                        </b-col> -->
                        <b-col cols="4">
                            <label>Quotation Status</label>
                            <b-form-select v-model="search.state" :disabled="state === 'loadingData'">
                                <b-form-select-option v-for="(item, index) in statusList" :key="index" :value="item.id">{{item.description}}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="4">
                            <label>Quotation Type</label>
                            <b-form-select v-model="search.type" :disabled="state === 'loading'">
                                <b-form-select-option v-for="(item, index) in typeList" :key="index" :value="item.id">{{item.description}}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <label>Company</label>
                            <b-form-select v-model="search.businessUnits">
                                <b-form-select-option v-for="(item, index) in companiesList" :key="index" :value="item.key">{{item.value}}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="4">
                            <label>Date Created From</label>
                            <b-form-datepicker v-model="search.dateCreatedFrom"></b-form-datepicker>
                        </b-col>
                        <b-col cols="4">
                            <label>Date Created To</label>
                            <b-form-datepicker v-model="search.dateCreatedTo"></b-form-datepicker>
                        </b-col>
                    </b-row>
                    <hr class="mx-3" />
                    <b-row>
                        <b-col cols="12" class="text-right">
                            <b-button variant="red" squared class="mr-2" @click="clearFilter()">Cancel</b-button>
                            <b-button variant="primary" squared @click="searchResults()">Search</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-card>
                    <b-row>
                        <p class="bold">Quote State division</p>
                    </b-row>
                    <b-row align-h="center">
                        <div class="w-100 text-center my-2" v-if="state === 'loading'">
                            <b-spinner style="width: 3rem; height: 3rem;"></b-spinner>
                        </div>
                        <pie-chart v-if="state !== 'loading'" :data="chartData" :options="chartOptions" :height="340"
                            class="graph-display"></pie-chart>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="8" class="m-0 p-0">
                <b-row>
                    <b-col class="text-right mb-2">
                        <b-button variant="primary" squared @click="exportResults()">
                             <b-spinner v-if="isDownloading" small></b-spinner>
                             Export to .xls
                        </b-button>
                    </b-col>
                </b-row>
                <b-row class="m-0 p-0">
                    <b-col cols="6">
                        <b-card>
                            <p class="bold">Total Records</p>
                            <h2 class="text-right mb-0">{{displayValues.totalRecords}}</h2>
                        </b-card>
                    </b-col>
                    <b-col cols="6">
                        <b-card>
                            <p class="bold">Aggregate Total</p>
                            <h2 class="text-right mb-0">R {{displayValues.total}}</h2>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row class="m-0 p-0 mt-3">
                    <b-col cols="6">
                        <b-card>
                            <p class="bold">Expired Quote Count</p>
                            <h2 class="text-right mb-0">{{displayValues.expiredCount}}</h2>
                        </b-card>
                    </b-col>
                    <b-col cols="6">
                        <b-card>
                            <p class="bold">Expired Quote Accumalative Cost</p>
                            <h2 class="text-right mb-0">R {{displayValues.expiredCost}}</h2>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import PieChart from "@/components/charts/pieChart.js";

export default {
    name: 'Logger',
    components: {
      PieChart
    },
    data: () => ({
        isDownloading: false,
        state: 'loading',
        newQuoteTicket: null,
        statusList: [],
        typeList: [],
        chartOptions: {
            hoverBorderWidth: 20
        },
        chartData: {},
        displayValues: {
            expiredCount: 0,
            expiredCost: 0,
            totalRecords: 0,
            total: 0
        },
        isLoading: true,
        companiesList: [],
        search:{
            type: null,
            dateCreatedFrom: null,
            dateCreatedTo: null,
            state: null,
            jobCardNumber: null,
            customer: null,
            businessUnits: null,
            clients: null
        }
    }),
    created(){
        this.setBreadcrumb([
            {
                text: 'Quotes'
            },
            {
                text: 'Reporting',
                active: true
            }
        ])
        this.getCompanyList()
        .then((res) => {
            this.companiesList = res.data
        })
        this.state = 'loading'
        this.getQuoteTypeList()
        .then((res) => {
            this.typeList = res.data
            this.getStatusList()
            .then((res) => {
                this.statusList = res.data
                this.searchResults()
            })
        })
        
    
    },
    methods:{
        ...mapActions(['getStatusList', 'getQuoteTypeList', 'getQuoteSummary', 'getCompanyList','exportQuoteSummary']),
        ...mapMutations('breadcrumbService', ['setBreadcrumb']),
        clearFilter(){
            this.search = {
                type: null,
                dateCreatedFrom: null,
                dateCreatedTo: null,
                state: null,
                jobCardNumber: null,
                customer: null,
                businessUnits: null,
                clients: null
            }
        },
        searchResults(){
            this.state = 'loading'
            let request = []
            if(this.search.state !== null){
                request.push({"key":"fkstatusId","value": this.search.state})
            }
            if(this.search.type !== null){
                request.push({"key":"FkQuoteTypeId","value": this.search.type})
            }
            if(this.search.jobCardNumber !== null){
                request.push({"key":"ticketNumber","value": this.search.jobCardNumber})
            }
            if(this.search.businessUnits !== null){
                request.push({"key":"FkBusinessUnitId","value": this.search.businessUnits})
            }
            if(this.search.customer !== null){
                request.push({"key":"Client","value": this.search.customer})
            }
              if(this.search.dateCreatedFrom !== null){
                request.push({"key":"CreatedDateFrom","value": this.search.dateCreatedFrom})
            }
              if(this.search.dateCreatedTo !== null){
                request.push({"key":"CreatedDateTo","value": this.search.dateCreatedTo})
            }
            // if(this.search.client !== null){
            //     request.push({"key":"client","value": this.search.client})
            // }

            //console.log('request for search', request)
            //console.log(JSON.stringify(request))
            this.$store.commit('setQuoteSummaryRequest', request)
            this.getQuoteSummary()
            .then((res) => {
                //console.log('asdadad', res)
                this.displayValues = {
                    expiredCount: res.data.expiredCount,
                    expiredCost: res.data.expiredCost,
                    totalRecords: res.data.totalRecords,
                    total: res.data.total
                }
            
              
                let infoLabels = []
                let colours = ['#00AC64', '#00AEEF', '#008694']
                let info = []

                for (let i = 0; i < res.data.stateList.length; i++) {
                    const element = res.data.stateList[i];
                    info.push(element.value)
                    infoLabels.push(element.key)
                }
            this.json_data = res.data.stateList

            this.chartData = {
              hoverBackgroundColor: "red",
              hoverBorderWidth: 10,
              labels: infoLabels,
              datasets: [{
                label: "Data One",
                backgroundColor: colours,
                data: info
              }]
            }


            // this.dashboardInfo.wattsUsed = response.data.percentageWattsUsed.toFixed(0)
            // this.dashboardInfo.wattsGenerated = response.data.percentagewattsGenerated.toFixed(0)
            // this.dashboardInfo.batteryPercentage = response.data.batteryPercentile.toFixed(1)

            // this.lastEventDate = response.data.lastEventDate

            //     this.tableData.dataSource = res.data
                this.state = 'show'
            })
            .catch(() => {
                this.state = 'show'
            })
        },
        exportResults(){
            this.isDownloading = true
            let request = []
            if(this.search.state !== null){
                request.push({"key":"FkStatusId","value": this.search.state})
            }
            if(this.search.type !== null){
                request.push({"key":"FkQuoteTypeId","value": this.search.type})
            }
            if(this.search.jobCardNumber !== null){
                request.push({"key":"ticketNumber","value": this.search.jobCardNumber})
            }
            if(this.search.businessUnits !== null){
                request.push({"key":"FkBusinessUnitId","value": this.search.businessUnits})
            }
            if(this.search.customer !== null){
                request.push({"key":"Client","value": this.search.customer})
            }
              if(this.search.dateCreatedFrom !== null){
                request.push({"key":"CreatedDateFrom","value": this.search.dateCreatedFrom})
            }
              if(this.search.dateCreatedTo !== null){
                request.push({"key":"CreatedDateTo","value": this.search.dateCreatedTo})
            }
            // if(this.search.client !== null){
            //     request.push({"key":"client","value": this.search.client})
            // }

            //console.log('request for export', request)
            //console.log(JSON.stringify(request))
            this.$store.commit('setQuoteSummaryRequest', request)
            this.exportQuoteSummary() //should be exportQuoteSummary
            
            .then((res) => {
                this.fetchingData = false

                if (res.data !== '') {
                    const linkSource = `data:${res.data.contentType};base64,${res.data.base64Data}`;
                    const downloadLink = document.createElement("a");

                    downloadLink.href = linkSource;
                    downloadLink.download = res.data.fileName;
                    downloadLink.click();
                }
                else{
                this.addWarningMessage('No data available to download')
                }
                this.isDownloading = false
            })
            .catch(() => {
                this.fetchingData = false
                this.isDownloading = false
            })
        }

    },
    computed:{
    }
}
</script>
